export default "__VITE_ASSET__BYlyUOJK__"